import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { modelsData } from '../data/modelsData';
import '../ModelDetail.css';

// Импортируем компоненты верстки
import MotorradHeader from '../components/MotorradHeader';
import MotorradFooter from '../components/MotorradFooter';
import MotorradTestDrive from './MotorradTestDrive'; 

// Используем наш единый настроенный API-сервис вместо «голого» axios
import { sendFrontAction } from '../services/api';

const ModelDetail = () => {
    const { id } = useParams(); 
    
    const [model, setModel] = useState(modelsData[id] || null);
    const [activeColor, setActiveColor] = useState(null);
    const [loading, setLoading] = useState(!modelsData[id]); 
    
    const specificationsRef = useRef(null);

    useEffect(() => {
        if (model && model.colors && model.colors.length > 0) {
            setActiveColor(model.colors[0]);
        }
    }, [model]);

    useEffect(() => {
        window.scrollTo(0, 0);

        const fetchMotoData = async () => {
            try {
                const response = await sendFrontAction('motorrad', { slug: id });
                
                // Проверяем структуру ответа (обычно данные приходят в поле data)
                const motoData = response?.data ? response.data : response;

                if (motoData) {
                    setModel(prevModel => ({
                        ...prevModel, 
                        ...motoData, // Сюда прилетит и перепишет поля, включая name и hasTestDrive
                    }));
                }
            } catch (error) {
                console.error("Ошибка запроса мото-данных через диспетчер:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchMotoData();

        const blocks = document.querySelectorAll('.specs-category-block');
        const observerOptions = { root: null, rootMargin: '0px 0px -100px 0px', threshold: 0.15 };

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) entry.target.classList.add('visible');
            });
        }, observerOptions);

        blocks.forEach(block => observer.observe(block));

        return () => {
            blocks.forEach(block => observer.unobserve(block));
        };
    }, [id]);

    if (loading) return <div className="not-found">Загрузка данных о мотоцикле...</div>;
    if (!model) return <div className="not-found">Модель мотоцикла не найдена в системе</div>;

    return (
        <div className="model-detail-page">
            
            {/* 1. HERO SECTION */}
            <section className="model-hero">
                <img src={model.mainImage || model.main_image} alt={model.name} className="hero-bg" />
                <div className="hero-title-box">
                    <h1>{model.name}</h1>
                    <p>{model.subTitle || model.subtitle}</p>
                </div>
            </section>

            {/* 4. COLOR SELECTOR */}
            {model.colors && model.colors.length > 0 && (
                <section className="color-selector-section">
                    <div className="container">
                        <div className="bike-display">
                            <img src={activeColor?.img} alt="Bike color" className="active-bike-img" />
                        </div>
                        <div className="color-controls">
                            <h3>Цвет: {activeColor?.name}</h3>
                            <div className="color-dots">
                                {model.colors.map(color => (
                                    <div 
                                        key={color.id}
                                        className={`color-dot ${activeColor?.id === color.id ? 'active' : ''}`}
                                        style={{ backgroundColor: color.hex }}
                                        onClick={() => setActiveColor(color)}
                                    />
                                ))}
                            </div>
                        </div>
                    </div>
                </section>
            )}

            {/* 3. FEATURES GRID */}
            {model.features && model.features.length > 0 && (
                <section className="features-seamless-section">
                    <div className="seamless-container">
                        <h2 className="seamless-main-title">ИДЕАЛЬНОЕ СОЧЕТАНИЕ ХАРАКТЕРИСТИК</h2>
                        <div className="seamless-grid">
                            {model.features.map((f, index) => (
                                <div key={f.id || index} className="seamless-card">
                                    <div className="seamless-img-wrapper">
                                        <img src={f.img || f.image_url} alt={f.title} />
                                    </div>
                                    <div className="seamless-overlay-info">
                                        <div className="seamless-overlay-content">
                                            <h4>{f.title}</h4>
                                            <p>{f.desc || f.description}</p>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>
            )}

            {/* 5. TECH SPECS */}
            <section className="specs-section" ref={specificationsRef}>
                {/* ... Оставляем вашу верстку характеристик без изменений ... */}
            </section>

            {/* 6. EQUIPMENT */}
            {model.equipment && (model.equipment.standard || model.equipment.special) && (
                <section className="equipment-section">
                    {/* ... Оставляем верстку комплектации ... */}
                </section>
            )}

            {/* 🔥 УМНЫЙ ВЫВОД ФОРМЫ ТЕСТ-ДРАЙВА */}
            {model.hasTestDrive !== false ? (
                <div id="test-drive-section">
                    {/* Передаем текущую модель дефолтным значением в форму, если нужно */}
                    <MotorradTestDrive defaultBike={model.name} />
                </div>
            ) : (
                <div className="test-drive-disabled-banner">
                    <p>Данная модель мотоцикла временно недоступна для тест-драйва в дилерском центре.</p>
                </div>
            )}
            
        </div>
    );
};

export default ModelDetail;